app.controller("SearchResultAreaController",
	["$rootScope", "$scope", "$timeout", "ApartmentSearchModel", "ApartmentSearchService", function($rootScope, $scope, $timeout, ApartmentSearchModel, ApartmentSearchService) {

		$scope.SearchModel = ApartmentSearchModel;
		$scope.searchID = "";
		$scope.searchResults = ApartmentSearchModel.results[$scope.searchID];

		$scope.$watch('searchResults.loading', function(newVal) {
			if(!newVal && $scope.packery && window['isIE']) {
				$timeout(function() {
					if($scope.packeryControls !== undefined) {
						$scope.packeryControls.ResetAndReLayout();
					}
				});
			}
		});

		$scope.Init = function(searchID) {
			$scope.searchID = searchID;
			if(ApartmentSearchModel.results[searchID] === undefined) {
				ApartmentSearchModel.results[searchID] = {};
			}
			$scope.searchResults = ApartmentSearchModel.results[searchID];
			$rootScope.searchResults = ApartmentSearchModel.results[searchID];
		};

		$scope.PackeryInit = function(packery, controls) {
			if (!window['isIE']) {
				return;
			}
			$scope.packery = packery;
			$scope.packeryControls = controls;
			controls.ResetAndReLayout();
		};

		$scope.getHouseImage = function (house) {
			if (house.images && house.images.length) {
				var imageObj = house.images.filter(function (image) {
					return image.type === 'MAIN';
				});

				if (imageObj[0] && imageObj[0].path && imageObj[0].name) {
					return '/assets' + imageObj[0].path + '/w_604,h_392,c_zoom/' + imageObj[0].name;
				} else {
					return '/assets/images/list/noimage-tiny.png';
				}
			} else {
				return '/assets/images/list/noimage-tiny.png';
			}
		};
	}]
);